@if (!!oid) {
  <div>
    <h1>{{ title }}</h1>
    @if (isLoading) {
      <mat-spinner [diameter]="18"></mat-spinner>
    }
    @if (!!alert) {
      <h2>{{ alert.properties.headline}}</h2>
      <pre>{{ alert.properties.description}}</pre>
    }

    @if (!!alert?.properties?.instruction) {
      <h2>Instruction</h2>
      <pre>{{ alert.properties.instruction}}</pre>
    }
  </div>
}
